import React from 'react';
import { ProductUploadTemplate } from 'themes/application/product/pages';
import { observer } from 'mobx-react';
import { ProductUploadViewStore } from 'application/product/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ProductUploadViewStore(rootStore), 'productUploadViewStore')
@observer
class ProductUpload extends React.Component {
    render() {
        return <ProductUploadTemplate {...this.props} />
    }
}

export default ProductUpload;